import IEvent from '@/models/dto/IEvent'
import { EventTypeEnum } from '@/models/enum-types/event-type.enum'
import EventStrategy from './event.strategy'
import GeofenceStrategy from './geofence.event.strategy'
import ModemEventStrategy from './modem.event.strategy'
import OverspeedStrategy from './overspeed.strategy'

export default class EventStrategyFactory {
    static map(event: IEvent): EventStrategy {
        if (event.type === 'alarm') {
            switch (event.attributes.alarm) {
                case 'powerCut':
                    return new ModemEventStrategy(
                        EventTypeEnum.BATTERY_DISCONNECT_EVENT,
                        event,
                        'DESCONEXIÓN DE BATERÍA'
                    )
                case 'powerRestored':
                    return new ModemEventStrategy(EventTypeEnum.BATTERY_CONNECTION_EVENT, event, 'CONEXIÓN DE BATERÍA')
                case 'sos':
                    return new ModemEventStrategy(EventTypeEnum.SOS_EVENT, event, 'ALERTA DE PÁNICO')
                case 'closeFuelTank':
                    return new ModemEventStrategy(EventTypeEnum.CLOSE_FUEL_TANK, event, 'ALERTA DE TANQUE CERRADO')
                case 'openFuelTank':
                    return new ModemEventStrategy(EventTypeEnum.OPEN_FUEL_TANK, event, 'ALERTA DE TANQUE ABIERTO')
                case 'closeSideDoor':
                    return new ModemEventStrategy(EventTypeEnum.CLOSE_SIDE_DOOR, event, 'PUERTA LATERAL CERRADA')
                case 'openSideDoor':
                    return new ModemEventStrategy(EventTypeEnum.OPEN_SIDE_DOOR, event, 'PUERTA LATERAL ABIERTA')
                case 'sosOn':
                    return new ModemEventStrategy(EventTypeEnum.SOS_EVENT, event, 'PÁNICO 2 ACTIVADO')
                case 'sosOff':
                    return new ModemEventStrategy(EventTypeEnum.SOS_EVENT, event, 'PÁNICO 2 DESACTIVADO')
                case 'openBackDoor':
                    return new ModemEventStrategy(EventTypeEnum.OPEN_BACK_DOOR, event, 'PUERTA TRASERA ABIERTA')
                case 'closeBackDoor':
                    return new ModemEventStrategy(EventTypeEnum.CLOSE_BACK_DOOR, event, 'PUERTA TRASERA CERRADA')
                case 'vehicleOn':
                    return new ModemEventStrategy(EventTypeEnum.VEHICLE_ALARM_ON, event, 'ALARMA VEHICULAR ACTIVADA')
                case 'vehicleOff':
                    return new ModemEventStrategy(
                        EventTypeEnum.VEHICLE_ALARM_OFF,
                        event,
                        'ALARMA VEHICULAR DESACTIVADA'
                    )
                case 'lowBattery':
                    return new ModemEventStrategy(EventTypeEnum.LOW_BATTERY_EVENT, event, 'BATERÍA BAJA')
                default:
                    return new ModemEventStrategy(EventTypeEnum.UNKNOWN_EVENT, event, 'EVENTO DESCONOCIDO')
            }
        } else {
            switch (event.type) {
                case 'deviceOverspeed':
                    return new OverspeedStrategy(EventTypeEnum.SPEEDING_EVENT, event, 'EXCESO DE VELOCIDAD')
                case 'geofenceExit':
                    return new GeofenceStrategy(EventTypeEnum.GEOFENCE_EXIT_EVENT, event, 'SALIDA DE GEOCERCA')
                case 'geofenceEnter':
                    return new GeofenceStrategy(EventTypeEnum.GEOFENCE_ENTER_EVENT, event, 'ENTRADA A GEOCERCA')
                case 'maintenance':
                    return new GeofenceStrategy(EventTypeEnum.GEOFENCE_ENTER_EVENT, event, 'MANTENIMIENTO')
                default:
                    return new ModemEventStrategy(EventTypeEnum.UNKNOWN_EVENT, event, 'NaN')
            }
        }
    }
}
